import { inject, observer } from 'mobx-react';

import Icons from 'bz-core-controls/icons';
import React from 'react';
import { computed } from 'mobx';
import ProntoReportStatus from 'bz-pronto-core/enum/pronto-report-status';
import { Button } from '@material-ui/core';

@inject('vm')
@observer
class Icon extends React.Component {
  render() {
    let { vm } = this.props;

    if (this.alert) {
      return <Button disabled={vm.loading}>{Icons.alert}</Button>;
    }

    return (
      <Button disabled={vm.loading}>
        <svg width={16} height={16} viewBox="0 0 24 24" className="morph-arrow">
          <g transform={`rotate(${this.chevron}, 12, 12)`}>
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </g>
        </svg>
      </Button>
    );
  }

  @computed
  get chevron() {
    let { open, loading } = this.props.vm;
    return !!open && !loading ? '270' : '180';
  }

  @computed
  get alert() {
    let { status, report } = this.props.vm;
    return status !== 'normal' || (!!report && report.status === ProntoReportStatus.Rejected);
  }
}

export default Icon;
